import { VendorsTableDataType } from "@pd/layouts/MktplaceDashboard/pages/Vendors/types";
import { VendorInfoDbType } from "@pd/redux/types/dbTypes";

// eslint-disable-next-line import/prefer-default-export
export function isVendorCardIneligible(
  vendor: VendorInfoDbType | VendorsTableDataType,
): boolean {
  return !vendor.cardActive || vendor.cardDisabled || !vendor.cardPushEnabled;
}
